import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./highlights-trust.css";
import HighlightLine from "./highlights-line";
import { FaCaretRight } from "react-icons/fa6";

export default function HighlightsTrust() {
  const [counterOn, setCounterOn] = useState(false);

  return (
    <div>
      <ScrollTrigger
        onEnter={() => setCounterOn(true)}
        onExit={() => setCounterOn(false)}
      >
        <div className="r-part">
          <div className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp
                start={0}
                end={8585}
                decimals={0}
                duration={2}
                delay={0}
              />
            )}
            <span className="card-circle card-circle-support-01">E10</span>
            <div 
              className="hover-area-home-page hover-area-home-page-support-01"
            >
              <p className="tooltip-texts-home-page">Zero Waste to Landfill</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </div>
          <p className="values-para">
            Children reached via education programs, exceeding the 5,600 target
          </p>
          <div className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp
                start={0}
                end={14979}
                decimals={0}
                duration={2}
                delay={0}
              />
            )}
            <span className="card-circle card-circle-support-02">E8</span>
            <div 
              className="hover-area-home-page hover-area-home-page-support-02"
            >
              <p className="tooltip-texts-home-page">Harvest Minimum 10% of Domestic Water from Rainwater</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </div>
          <p className="values-para">
            people reached via healthcare programs, exceeding 5,600 target
          </p>
          <div className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp
                start={0}
                end={5600}
                decimals={0}
                duration={2}
                delay={0}
              />
            )}
            <span className="card-circle card-circle-support-03">E7</span>
            <div 
              className="hover-area-home-page hover-area-home-page-support-03"
            >
              <p className="tooltip-texts-home-page">Recycle over 50% of Industrial Wastewater for Industrial Processes</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </div>
          <p className="values-para">
            Trees planted in mangrove regeneration projects
          </p>

          <div className="horizontal-line" />
          <div style={{ paddingBottom: "120px" }} />
        </div>
        <HighlightLine />
        <div style={{ paddingBottom: "1px" }} />
        <div className="mobile">
          <div style={{ paddingBottom: "10px" }} />
        </div>
      </ScrollTrigger>
    </div>
  );
}
